import { UuidProjectType, selectIsUuidBasedProject, selectUuidProjectType } from 'core/userContext';
import { useSelector } from 'react-redux';
import { STARRED_FIELDS } from '../../../../constants';

/**
 * [Email] is selected by default for email based projects
 * [Email, UserId] is selected by default for hybrid projects
 * [UserId] is selected by default for unique userId only projects
 */

export const useDefaultSelectedFields = () => {
  const isUuidProject = useSelector(selectIsUuidBasedProject);
  const uuidProjectType = useSelector(selectUuidProjectType);

  if (isUuidProject && uuidProjectType === UuidProjectType.EmailNonUnique) {
    // check if Email only
    return [STARRED_FIELDS.userId.toString()];
  } else if (!isUuidProject && uuidProjectType === UuidProjectType.EmailUnique) {
    // check if UserId only
    return [STARRED_FIELDS.email.toString()];
  } else {
    // check if Hybrid
    return [STARRED_FIELDS.email.toString(), STARRED_FIELDS.userId.toString()];
  }
};
